
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { API_TAttachment } from "@/models/report";

const ICONS = {
  trash: "trash-outline",
};

@Component({
  components: {},
})
export default class Attachments extends Vue {
  loading = false;

  error = false;

  icons = ICONS;

  isUploaderOpen = false;

  files: File[] = [];

  uploaderLoading = false;

  uploaderErrorText = "";

  toBeSentLoading = false;

  get serviceId(): number {
    return Number(this.$route.params.id ?? 0);
  }

  attachments: API_TAttachment[] = [];

  attachementLoading = false;

  async fetchAttachement() {
    try {
      this.attachementLoading = true;

      const { serviceId } = this;

      if (!serviceId) return;

      const { data } = await this.axios.get<API_TAttachment[]>(
        API_ROUTES.CASES_REPORT_ATTACHEMENT(serviceId)
      );

      this.attachments = data;
    } catch {
      this.error = true;
    } finally {
      this.attachementLoading = false;
    }
  }

  mounted() {
    this.fetchAttachement();
  }

  async changeToBeSent(id: number, toBeSent: boolean) {
    this.toBeSentLoading = true;

    const { serviceId } = this;

    if (!serviceId) return;

    try {
      await this.axios.get(
        API_ROUTES.CASES_REPORT_ATTACHEMENT_TO_BE_SENT(serviceId, id, !toBeSent)
      );

      this.attachments.find((attachment) => attachment.ID === id).to_be_send = !toBeSent;
    } catch {
      this.error = true;
    } finally {
      this.toBeSentLoading = false;
    }
  }

  async onUploaderSave() {
    if (!this.serviceId) return;

    try {
      this.uploaderLoading = true;

      this.uploaderErrorText = "";

      const formData = new FormData();

      this.files.forEach((file) => {
        formData.append("file", file);
      });

      const url = API_ROUTES.CASES_REPORT_ATTACHEMENT(this.serviceId);

      await this.axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      this.isUploaderOpen = false;
    } catch (error) {
      this.uploaderErrorText = this.$root.$tc("error.default");
    } finally {
      this.uploaderLoading = false;

      this.files = [];

      await this.fetchAttachement();
    }
  }

  async deleteAtachement(id: number) {
    try {
      await this.axios.delete(API_ROUTES.CASES_REPORT_ATTACHEMENT_DELETE(this.serviceId, id));
    } finally {
      await this.fetchAttachement();
    }
  }

  async regenerateAttachement() {
    try {
      this.attachementLoading = true;

      const { serviceId } = this;

      if (!serviceId) return;

      const { data } = await this.axios.get<API_TAttachment[]>(
        API_ROUTES.CASES_REPORT_ATTACHEMENT_GENERATE(serviceId)
      );

      this.attachments = data;
    } catch {
      this.error = true;
    } finally {
      this.attachementLoading = false;
    }
  }
}
